import { AppIcon } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, SxProps, Theme, Typography } from '@mui/material';

const PROFILE_PERMISSION_STRINGS = appStrings.modules.profile.permissionDenied;

type ViewPermissionDeniedProps = Readonly<{
  message?: string;
}>;

export const ViewPermissionDenied = ({ message }: ViewPermissionDeniedProps) => {
  const titleText =
    message === 'Background check required'
      ? PROFILE_PERMISSION_STRINGS.titleBackgroundCheck
      : PROFILE_PERMISSION_STRINGS.titleSafety;

  const descriptionText =
    message === 'Background check required'
      ? PROFILE_PERMISSION_STRINGS.descriptionBackgroundCheck
      : PROFILE_PERMISSION_STRINGS.descriptionSafety;

  return (
    <Box sx={containerSx}>
      <Typography variant="display-sm-medium" sx={titleSx}>
        <AppIcon iconName="Lock01" diameter="24px" color="Error/500" />
        {titleText}
      </Typography>

      <Typography variant="text-md-medium">{descriptionText}</Typography>
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '500px',
  height: 'fit-content',
  alignSelf: 'center',
  margin: '0 auto',
  marginX: { xs: backrs.spacing['spacing-xl'], sm: 'auto' },
  backgroundColor: backrs.colors['Colors/Base/White'],
  border: `1px solid ${backrs.colors['Colors/Border/border-primary']}`,
  borderRadius: backrs.radius['radius-2xl'],
  padding: {
    xs: backrs.spacing['spacing-xl'],
    sm: backrs.spacing['spacing-5xl'],
  },
  textAlign: { sm: 'center' },
});

const titleSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: backrs.spacing['spacing-xl'],
  gap: backrs.spacing['spacing-sm'],
  color: backrs.colors['Colors/Text/text-primary'],
  flexWrap: 'wrap',
});
